/**
 * ComplianceModal - Displays compliance warning when user logs into router
 * Shows once per day and requires acceptance to maintain router login
 */

import React from "react";
import PropTypes from "prop-types";
import SimpleModal from "./SimpleModal";
import "./ComplianceModal.css";

const ComplianceModal = ({ visible, onAccept, onReject }) => {
  return (
    <SimpleModal
      title="Aviso"
      visible={visible}
      onHide={onReject}
      onConfirm={onAccept}
      confirmLabel="Aceitar e Continuar"
      cancelLabel="Recusar"
      showCancel={true}
      size="large"
      variant="warning"
      closable={false}
      className="compliance-modal"
    >
      <div className="compliance-content">
        <div className="compliance-message">
          <p>
            Se você estiver executando ordens em mais de uma plataforma que não
            seja do Tradezone, poderá ocorrer duplicidade de posição e
            resultados imprecisos no Tradezone e demais plataformas.
          </p>
          <p>
            Sempre verifique suas posições, ordens e resultados no{" "}
            <strong>Home Broker</strong>. Ele é a única ferramenta que apresenta
            todas as suas transações.
          </p>
          <p>
            Lembrando que você deve utilizar o HB para visualizar e gerir suas
            posições. Em caso de divergência de informação, zere sua posição
            pelo HB e desconsidere qualquer outra informação que não esteja no
            HB.
          </p>
        </div>

        <div className="compliance-warning">
          <i className="pi pi-exclamation-triangle"></i>
          <span>
            Você deve aceitar este aviso para continuar usando o roteador.
          </span>
        </div>
      </div>
    </SimpleModal>
  );
};

ComplianceModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
};

export default ComplianceModal;
